import { useState } from "react";
import { BiPlus } from "react-icons/bi";
import { AiOutlineWarning, AiOutlineCheckCircle } from "react-icons/ai";
import Swal from "sweetalert2";
import { Modal, Form } from "react-bootstrap";
import GuardedModal from "../../common/GuardedModal";
import { Button } from "semantic-ui-react";
import axios from "axios";

import { headers } from "../../global_vars";
import { useMergedModalVisibility } from "../../common/useMergedModalVisibility";
import { NESTED_MODAL_PROPS } from "../../common/nestedModalProps";

window.Swal = Swal;

const CREATE_ISSUANCE_AUTHORITY =
  "https://ultima.icsgr.com/api/administration/all_issuance_authorities/";

const clampLen = (value, max) => value.slice(0, max);

export default function AddIssuanceAuthorityModal({
  onIssuanceAuthorityCreated,
  show: showProp,
  onHide: onHideProp,
  hideTrigger = false,
  nested = false,
}) {
  const { show, open, close } = useMergedModalVisibility(showProp, onHideProp);
  const [title, setTitle] = useState("");

  const handleClose = () => {
    close();
    setTitle("");
  };

  const isTitleValid = title.trim().length >= 2 && title.trim().length <= 80;
  const isFormValid = isTitleValid;

  const createNewIssuanceAuthority = async () => {
    if (!isFormValid) return;

    try {
      const currentHeaders = {
        ...headers,
        Authorization: "Token " + localStorage.getItem("userToken"),
      };

      const res = await axios.post(
        CREATE_ISSUANCE_AUTHORITY,
        { title: title.trim(), active: true },
        { headers: currentHeaders }
      );

      handleClose();

      if (typeof onIssuanceAuthorityCreated === "function") {
        try {
          await Promise.resolve(onIssuanceAuthorityCreated(res.data));
        } catch (_) {}
      }
    } catch (e) {
      let apiMsg = "Failed to create issuance authority.";
      const data = e?.response?.data;
      if (data?.error) apiMsg = data.error;
      else if (data?.title) apiMsg = Array.isArray(data.title) ? data.title[0] : data.title;
      else if (data?.detail) apiMsg = data.detail;

      Swal.fire({
        icon: "error",
        title: "Error",
        text: apiMsg,
      });
    }
  };

  return (
    <>
      {!hideTrigger && (
        <Button onClick={() => open()} color="green" style={{ margin: 20 }}>
          <BiPlus style={{ marginRight: 6 }} />
          New Issuance Authority
        </Button>
      )}

      <GuardedModal
        show={show}
        onHide={handleClose}
        centered
        {...(nested ? NESTED_MODAL_PROPS : {})}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Issuance Authority</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Authority *</Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => setTitle(clampLen(e.target.value, 80))}
              placeholder="e.g. Α.Τ. ΚΟΛΩΝΑΚΙ or Passport Office Athens"
            />
            <Form.Text className="text-muted">
              Police department or passport office that issued the document (2–80 characters).
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <small className="mr-auto">
            {!isFormValid ? (
              <ul className="mr-auto" style={{ margin: 0, padding: 0, color: "red" }}>
                <li>
                  <AiOutlineWarning style={{ fontSize: 18, marginRight: 6 }} />
                  Authority name is required (2–80 chars).
                </li>
              </ul>
            ) : (
              <div style={{ color: "green" }}>
                <AiOutlineCheckCircle style={{ fontSize: 18, marginRight: 6 }} />
                Validated
              </div>
            )}
          </small>
          <Button color="red" onClick={handleClose}>
            Cancel
          </Button>
          <Button color="green" onClick={createNewIssuanceAuthority} disabled={!isFormValid}>
            Create
          </Button>
        </Modal.Footer>
      </GuardedModal>
    </>
  );
}
